/**
 * Artzy event layer — vendor-agnostic, consent-gated.
 *
 * Pushes to window.dataLayer using an object_action, lower_snake_case
 * taxonomy (rulepack R4) so whatever analytics platform is connected
 * later (GA4, GTM, etc.) can consume these without a rebuild.
 *
 * Consent (sheet 23, FLOOR item): every push is gated on Shopify's
 * Customer Privacy API. If that API hasn't loaded yet or reports
 * processing isn't allowed, the event is dropped, not queued -- this
 * fails closed rather than replaying events retroactively once
 * consent is granted, which is the simpler and safer default for a
 * FLOOR requirement ("nothing fires pre-consent").
 */
(function () {
  'use strict';

  function analyticsAllowed() {
    try {
      return !!(
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed()
      );
    } catch (error) {
      return false;
    }
  }

  function track(name, properties) {
    if (!analyticsAllowed()) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, properties || {}));
  }

  window.ArtzyEvents = { track: track, analyticsAllowed: analyticsAllowed };

  /**
   * product_added — the site's primary action (sheet 03: "Add a
   * personalized product to the cart from a product page"). Hooks the
   * theme's own cart-update pub/sub (assets/product-form.js) rather
   * than re-wiring the add-to-cart form, and only fires for actual
   * product-form submissions (source: 'product-form') -- cart drawer
   * quantity changes publish the same event with a different source
   * and must not double-count as an add.
   */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (!data || data.source !== 'product-form' || !data.cartData) return;

      const items = data.cartData.items || [];
      const addedItem = items.find(function (item) {
        return String(item.variant_id) === String(data.productVariantId);
      }) || items[items.length - 1];

      if (!addedItem) return;

      track('product_added', {
        product_id: addedItem.product_id,
        variant_id: addedItem.variant_id,
        product_title: addedItem.product_title || addedItem.title,
        price: addedItem.price,
        quantity: addedItem.quantity,
        personalized: !!(addedItem.properties && Object.keys(addedItem.properties).some(function (key) {
          return !key.startsWith('_') && addedItem.properties[key];
        })),
      });
    });
  }
})();
